export type InvitationStatus = {
    label: string;
    color: 'success' | 'error' | 'primary';
};

export const invitationStatus = (record: { used?: boolean; expiresAt?: string }): InvitationStatus => {
    if (record.used) {
        return { label: 'Eingelöst', color: 'success' };
    }

    if (record.expiresAt && new Date(record.expiresAt) < new Date()) {
        return { label: 'Abgelaufen', color: 'error' };
    }

    return { label: 'Offen', color: 'primary' };
};
